<template>
  <div>
    <el-radio-group v-model="tiemType" @change="timeTypeChange">
      <el-radio-button v-for="item in timeOption" :key="item.code" :label="item.code">{{item.desc}}</el-radio-button>
    </el-radio-group>
    <div class="box">
      <div class="item" v-for="item in config" :key="item.code">
        <p class="title">{{item.name}}</p>
        <p class="data"><span class="num">{{dataList[item.code] || '-'}}</span><span class="unit">{{unitList[item.unit]}}</span></p>
        <p>
          <span class="compareLabel">{{compareLabel}}</span>
          <img v-if="true" :src="getIcon(dataList[item.perCode])" alt="">
          <span :class="[className(dataList[item.perCode]), 'per']">{{getNumCompare(dataList[item.perCode])}}</span>
        </p>
      </div>
    </div>
    <div class="bottomBox">
      <img class="robot" src="../../../assets/image/workPlatform/robot.png" alt="">
      <div class="rightBox">
        <template>
          <div class="title"><p class="msg">{{randomMsg}}</p><p class="resetBtn" @click="reset">重新分析</p></div>
          <div class="box2" v-if="drawList.length">
            <div class="li" v-for="(item, i) in drawList" :key="i">
              <img class="tip" src="../../../assets/image/icon/tip.png" alt="">
              <span class="msg" v-html="getXssIntro(getRecommendDesc(item))"></span>
              <span
              :class="['rightBtn', getBtnType(item).type?'click':'dis']"
              @click="operation(item)"
              >{{getBtnType(item).name}}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import rise from '../../../assets/image/workPlatform/rise.png'
import fall from '../../../assets/image/workPlatform/fall.png'
import { conditionData, conditionDraw, conditionUnit } from '@/api/customer/index'
import { getXssIntro } from '@/utils/xss'

export default {
  props: {
    showDetail: {
      type: Boolean
    }
  },
  data () {
    return {
      tiemType: 0,
      randomMsg: '您好，智慧管家持续护航中～',
      timeOption: [
        {
          code: 0,
          desc: '今天'
        },
        {
          code: 1,
          desc: '昨日'
        },
        {
          code: 2,
          desc: '本周'
        },
        {
          code: 3,
          desc: '本月'
        }
      ],
      config: [
        {
          name: '交易数量',
          code: 'totalLitre', // 接口返回数据的code
          perCode: 'totalLitreCompare', // 接口返回百分比的code
          unit: 'OIL_NUM' // 后端单位接口返回的code
        },
        {
          name: '总销售额',
          code: 'amountGun',
          perCode: 'amountGunCompare',
          unit: 'MONEY'
        },
        {
          name: '订单数量',
          code: 'orderCnt',
          perCode: 'orderCntCompare',
          unit: 'ORDER'
        },
        {
          name: '新客交易人数',
          code: 'newUserNum',
          perCode: 'newUserNumCompare',
          unit: 'USER_NUM'
        }
      ],
      dataList: {},
      msgList: [ // 随机出现的三种提示
        '您好，经分析，当前下类客户群体可以进行精细营销，赶快去运营提升流水吧',
        '您好，经分析，您的油站存在潜在流水提升小妙诀，快去行动哟～',
        '您好，经分析，您的油站存在可进行精细化运营的用户，赶快行动吧！'
      ],
      unitList: {},
      drawList: []
    }
  },
  created () {
    this.getConditionData()
    if (!this.showDetail) return
    this.getConditionDraw()
    this.getConditionUnit()
  },
  methods: {
    getXssIntro,
    timeTypeChange (val) {
      this.getConditionData()
      this.$track.clickEvent('经营状况-时间筛选', '1638797369', { tysj_trade_type: val })
    },
    // 类名
    className (val) {
      if (val > 0) return 'rise'
      if (val < 0) return 'fall'
      return 'flat'
    },
    // 图标
    getIcon (num) {
      if (num > 0) return rise
      if (num < 0) return fall
    },
    // 百分比数据处理
    getNumCompare (num) {
      if (!num) return '-'
      return (num * 100).toFixed(2) + '%'
    },
    // 随机提示
    getMsg () {
      if (!this.showDetail) {
        this.randomMsg = '您好，智慧管家持续护航中～'
      } else if (!this.drawList.length) {
        this.randomMsg = '您好，经分析，油站经营状况良好，智慧管家持续护航中～'
      } else {
        let num = Math.round(Math.random()*2)
        this.randomMsg = this.msgList[num]
      }
    },
    // 重新分析
    reset () {
      this.$track.clickEvent('重新分析', '1638797371')
      this.$emit('reset')
    },
    // 画像文字描述
    getRecommendDesc (data) {
      let exe = data.recommendDesc
      if  (!exe) return ''
      let html1 = '<i class="el-icon-loading"></i>'
      let html2 = `<span style="color: red">${data.userCount}</span>`
      exe = exe.replace(/%\w*%/g, data.userCount ? html2 : html1)
      return exe
    },
    // 画像按钮
    getBtnType (data) {
      let op = {}
      // type 1为正常跳转 2为不可跳转 0为不可点击
      if (!data.gasLimit && data.canSend) {
        op.name = '立即发券 >'
        op.type = data.userCount ? 1 : 2
      } else {
        op.name = '今日创建任务已达上限'
        op.type = 0
      }
      return op
    },
    // 立即发券按钮
    operation (data) {
      const { type } = this.getBtnType(data)
      if(!type) return
      if (type === 1) {
        // 跳转页面
        let exe = data.recommendDesc.replace(/%\w*%/g, data.userCount)
        this.$track.clickEvent('立即发券', '1638797372', { tysj_click_content: exe})
        const { crowId, target, groupId } = data
        this.$router.push({ path: '/vipMarket/sendCoupon', query: { id: crowId, target, groupId } })
      } else {
        this.$message.error('数据据已更新，请刷新重试');
      }
    },
    async getConditionData () {
      let time = ''
      let cycle = ''
      if (this.tiemType === 0 ) {
        time = moment().format('YYYY-MM-DD HH:mm:ss')
        cycle = 'HOUR'
      } else if (this.tiemType === 1) {
        time = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        cycle = 'DAY'
      } else if (this.tiemType === 2) {
        time = moment().format('YYYY-MM-DD HH:mm:ss')
        cycle = 'WEEK'
      } else if (this.tiemType === 3) {
        time = moment().format('YYYY-MM-DD HH:mm:ss')
        cycle = 'MONTH'
      } 
      const { code, result } = await conditionData({ time, cycle })
      if (code!==200) return
      this.dataList = result
    },
    async getConditionDraw () {
      try {
        const { code, result } = await conditionDraw()
        if (code!==200) return
        this.drawList = result
      } catch (error) {
        console.log(console.error())
      } finally {
        this.getMsg()
      }
    },
    async getConditionUnit () {
      const { code, result } = await conditionUnit()
      if(code !== 200) return
      this.unitList = result
    }
  },
  computed: {
    compareLabel () {
      let txt = ''
      switch (this.tiemType) {
        case 0:
        case 1:
          txt = '较上日'
          break;
        case 2:
          txt = '较上周'
          break;
        case 3:
          txt = '较上月'
          break;
      }
      return txt
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #3377FF;
    background-color: #fff;
    border-color: #3377FF;
  }
  p {
    margin: 0;
  }
  .box {
    margin: 16px 0 22px;
    display: flex;
    justify-content: space-between;
    .item {
      // background: #FFFFFF;
      background: url('../../../assets/image/workPlatform/condition_bg.png') no-repeat top right #fff;
      border-radius: 4px;
      border: 1px solid #EAEAF4;
      width: 24%;
      padding: 15px;
      .title {
        font-size: 14px;
        color: #333;
        margin-bottom: 8px;
      }
      .data{
        margin-bottom: 8px;
        .num {
          font-size: 24px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: #3377FF;
          margin-right: 4px;
        }
        .unit {
          font-size: 14px;
          color: #333333;
        }
      }
      .compareLabel {
        font-size: 12px;
        color: #333333;
      }
      .per {
        font-size: 12px;
        font-weight: bold;
      }
      .rise {
        color: #F5222D;
      }
      .fall {
        color: #48C672;
      }
      .flat {
        color: #999999;
      }
    }
  }
  .bottomBox {
    display: flex;
    .robot {
      width: 56px;
      height: 56px;
      margin: 10px 16px 0 8px
    }
    .rightBox {
      width: 100%;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 12px;
        .msg {
          font-size: 16px;
          color: #666666;
          height: 22px;
          line-height: 22px;
        }
        .resetBtn {
          width: 85px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid #4B7EFE;
          color: #4B7EFE;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .box2 {
        width: 100%;
        height: 92px;
        background: #F8F9FD;
        padding: 16px;
        .li {
          height: 22px;
          line-height: 22px;
          margin-bottom: 16px;
          .tip {
            margin-right: 4px;
          }
          .msg {
            font-size: 16px;
            color: #1E1E28;
          }
          .rightBtn {
            float: right;
            font-size: 14px;
          }
          .click {
            color: #4B7EFE;
            cursor: pointer;
          }
          .dis {
            color: #666;
          }
        }
      }
    }
  }
</style>